import qs from 'query-string';
import React from 'react';
import Recaptcha from 'react-recaptcha';
import { connect } from 'react-redux';
import { ssoCheck } from 'src/actions/auth';
import config from 'src/appConfig';
import { CenteredLogo } from 'src/components';
import { PageLink } from 'src/components/links';
import { Box, Panel } from 'src/components/matchbox';
import { TranslatableText } from 'src/components/text';
import { AUTH_ROUTE, LINKS } from 'src/constants';
import { loadScript } from 'src/helpers/loadScript';
import { decodeBase64 } from 'src/helpers/string';
import RedirectAfterLogin from './components/RedirectAfterLogin';
import SsoLoginForm from './components/SsoLoginForm';

const { recaptcha } = config;

export class SsoAuthPage extends React.Component {
  state = {
    submitted: false,
    reCaptchaReady: false,
    recaptcha_response: null,
    recaptchaPass: false
  };

  recaptchaRef = React.createRef();

  reCaptchaLoaded = () => {
    this.setState({ reCaptchaReady: true });
  };

  recaptchaVerifyCallback = (response) => {
    this.setState({ recaptcha_response: response, recaptchaPass: true });
  };

  recaptchaExpiredCallback = () => {
    this.setState({ recaptcha_response: null, recaptchaPass: false });
  };

  resetRecaptcha = () => {
    this.setState({ recaptcha_response: null, recaptchaPass: false });
    if (this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };

  loginSubmit = ({ username }) => {
    this.setState({ submitted: true });
    this.props.ssoCheck(username, {
      recaptcha_response: this.state.recaptcha_response,
      recaptcha_type: 'checkbox',
      recaptcha_version: recaptcha.samlVersion
    });
  };

  componentWillReceiveProps(nextProps) {
    const { ssoUser, ssoToken, username, loginPending } = nextProps.auth;
    const prevLoginPending = this.props.auth.loginPending;

    if (ssoUser && ssoToken) {
      window.location.assign(
        `${config.apiBase}/v1/users/saml/login/${encodeURIComponent(
          username
        )}?sso_token=${encodeURIComponent(ssoToken)}`
      );
    }

    // Reset reCAPTCHA when SSO check completes without success (token was consumed)
    // This covers both SSO_CHECK_SUCCESS with ssoUser=false and SSO_CHECK_FAIL
    const ssoCheckFinished = prevLoginPending === true && loginPending === false;
    if (ssoCheckFinished && ssoUser !== true) {
      this.resetRecaptcha();
    }
  }

  render() {
    const { location, auth } = this.props;
    const { ssoUser, loginPending } = auth;
    const { submitted, reCaptchaReady, recaptchaPass } = this.state;
    const search = qs.parse(location.search);

    const IS_CYPRESS_RUNTIME = Boolean(
      window?.Cypress?.cy?.id && window?.Cypress?.env().RECAPTCHA_KEY
    );

    const shouldDisableInput = Boolean(!IS_CYPRESS_RUNTIME && !reCaptchaReady);
    const shouldDisableSubmit = Boolean(!IS_CYPRESS_RUNTIME && !recaptchaPass);

    const recaptchaKey = IS_CYPRESS_RUNTIME
      ? window?.Cypress?.env().RECAPTCHA_KEY
      : recaptcha.samlEnterpriseKey;

    const loginError =
      submitted && ssoUser === false ? (
        <TranslatableText>User is not set up to use single sign-on</TranslatableText>
      ) : (
        decodeBase64(search.error) // error comes base 64 encoded in url on redirect from 3rd party
      );

    if (auth.loggedIn) {
      return <RedirectAfterLogin />;
    }

    return (
      <React.Fragment>
        {/* eslint-disable-next-line local/restrict-translatable-text */}
        {loadScript({ url: LINKS.RECAPTCHA_LIB_URL })}
        <CenteredLogo />
        <Panel.LEGACY sectioned title={<TranslatableText>Single Sign-On</TranslatableText>}>
          <SsoLoginForm
            loginError={loginError}
            onSubmit={this.loginSubmit}
            disabledInput={shouldDisableInput}
            disabledSubmit={shouldDisableSubmit}
            loginPending={loginPending}
          />
          <Box mt="400">
            <Recaptcha
              ref={this.recaptchaRef}
              sitekey={recaptchaKey}
              render="explicit"
              onloadCallback={this.reCaptchaLoaded}
              verifyCallback={this.recaptchaVerifyCallback}
              expiredCallback={this.recaptchaExpiredCallback}
            />
          </Box>
        </Panel.LEGACY>
        <Panel.LEGACY.Footer
          left={
            <small>
              <PageLink to={AUTH_ROUTE}>Not looking for single sign-on?</PageLink>
            </small>
          }
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  auth
});

export default connect(mapStateToProps, { ssoCheck })(SsoAuthPage);
